import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import * as React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import { PinDropSharp } from '@mui/icons-material';
import { findAllRequestOfInstructor, acceptRequest, declineRequest } from '../../../API/Request';
import Avatar from '../../../assets/avatar.svg';
import EnrollStudentWithExcel from './enrollStudentWithExcel';
import CloseIcon from '@mui/icons-material/Close';








const PendingRequest = ({ fun, fake }) => {

    const [open, setOpen] = React.useState(false);
    const [pending, setPending] = React.useState([]);
    const [Data, UseData] = useState()
    const [disabled, setDisabled] = useState(false);
    const [reload,setReload] = useState(true)


    const handleClose = async () => {
        setDisabled(true);
        console.log("DAta on handle close", Data._id);
        await acceptRequest(Data._id);
        console.log("toast", toast.success)
        toast.success("request Accepted!");
        fun(!fake);
        setDisabled(false);
        setOpen(false);
    };
const handleDialogClose = () => {
    setDisabled(false);
    setOpen(false);
}

    const handleDeclineRequest = async () => {
        console.log("DAta on decline req", Data._id);
        setDisabled(true);
        await declineRequest(Data._id);
        toast.success("request declined successfully")

        fun(!fake);
        setDisabled(false);
        setOpen(false);


    }

    const handleDialog = (obj) => {
        console.log("obj of dialog", obj);
        setOpen(true);
        UseData(obj);

    }
    const takeInfo = async () => {
        const respo = await findAllRequestOfInstructor();
        console.log("respo", respo);
        //  setPending(respo.request);
        setPending(respo);

    }
    React.useEffect(() => {
        takeInfo();

    }, [fake]);

    return (
        // <Box sx={{ boxShadow: 18, borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }} sm={12} mb={7} p={1} pt={3} height='100%'>
        <Box
            sx={{
                borderRadius: '12px',
                p: { md: 3, sm: 2, xs: 2 },
                minHeight: '100%',
                backgroundColor: 'background.paper',
                border: '1px solid rgba(0, 0, 0, 0.08)'
            }}
            boxShadow={{ md: 4, sm: 0 }}
            sm={12}
            mb={7}
        >
            <div>

                <Dialog
                    open={open}
                    // onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"

                >
                    <DialogTitle id="alert-dialog-title">
                        <Stack direction="column">
                        <Stack direction="row" alignItems="center">
                            <img src={Avatar} width='32px' alt='avatar' />
                            <Typography sx={{ ml: 1 }} variant='h4'>
                                {Data?.studentId?.name}
                            </Typography>
                        </Stack>
                           <IconButton
                            aria-label="close"
                            onClick={handleDialogClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.error.main
                            }}
                           >
                           <CloseIcon />
                           </IconButton>
                        </Stack>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            From {Data?.courseId?.majorCategory} has requested to enroll in course name : <strong>{Data?.courseId?.courseName}</strong>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ pb: 2 }}>
                        <Button onClick={handleClose} disabled={disabled} variant='outlined' color='secondary'>
                            Accept Request
                        </Button>
                        <Button onClick={handleDeclineRequest} color='secondary'>Decline </Button>

                    </DialogActions>
                </Dialog>
            </div>
            <EnrollStudentWithExcel/>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '0.95rem' }}>
                    Pending Requests
                </Typography>
                {pending?.request?.length > 0 && (
                    <Button color='secondary' size='small' sx={{ fontWeight: 600, fontSize: '0.75rem', px: 1 }}>
                        ACCEPT ALL
                    </Button>
                )}
            </Stack>

            {pending?.request?.length > 0 ? (
                pending?.request?.map((item, idx) => (
                    <Stack
                        key={item._id || idx}
                        direction="row"
                        alignItems="center"
                        spacing={1.5}
                        mb={1.5}
                        p={1}
                        sx={{
                            cursor: 'pointer',
                            borderRadius: '8px',
                            transition: 'background-color 0.2s',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)'
                            }
                        }}
                        onClick={() => { handleDialog(item); }}
                    >
                        <img src={Avatar} width='32px' height='32px' alt='avatar' style={{ cursor: "pointer" }} />
                        <Typography
                            variant="body1"
                            sx={{ cursor: "pointer", fontWeight: 500 }}
                        >
                            {item.studentId?.name}
                        </Typography>
                    </Stack>
                ))
            ) : (
                <Typography variant='body2' sx={{ mt: 1, color: 'text.secondary' }}>
                    No Request pending
                </Typography>
            )}
            <ToastContainer />
        </Box>
    )
};

// PendingRequest.propTypes = {
//     fun: PropTypes.func.isRequired,
//     fake: PropTypes.bool.isRequired
// };

export default PendingRequest;

